import BaseDialog from '~/common/components/dialogs/BaseDialog';

import type { PropsWithChildren } from 'react';

export interface MessageProps extends PropsWithChildren {
  title?: string;
  confirmLabel?: string;
  maskClosable?: boolean;
  onConfirm?: () => void;
}

function MessageDialog({ title, children, confirmLabel, maskClosable, onConfirm }: MessageProps) {
  return (
    <BaseDialog
      title={title}
      cancelButtonProps={{ style: { display: 'none' } }}
      maskClosable={maskClosable}
      okText={confirmLabel || '확인'}
      onCancel={onConfirm}
      onOk={onConfirm}
    >
      {children}
    </BaseDialog>
  );
}

export default MessageDialog;
